

export const dbotReducer = (state = getEmptyState(), action) => {
  switch (action.type) {
    case "ADD_AND_INIT_BLOCK":
      state = {
        ...state,
        records: [...state.records, ...action.payload.records],
        blockApi: action.payload.blockApi,
        apis : addOrReplace(state.apis, action.payload.blockApi)
      };
      break;
    case "CLEAR_ADD_AND_INIT_BLOCK":
      state = {
        ...state,
        records: action.payload.records,
        blockApi: action.payload.blockApi,
        apis : addOrReplace(state.apis, action.payload.blockApi)
      };
      break;
    case "DBOT_CLEAR":
      return {...getEmptyState(), apis : state.apis};
    case "DBOT_CLICK":
      state = {
        ...state,
        records: [...state.records, ...(action.payload.records ? action.payload.records : [])]
      };
      break;

    case "LOAD_RECORDS":
      state = {
        ...state,
        records: action.payload.records,
        storedPointers: action.payload.storedPointers
      };
      break;
    case "SIGN_OUT":
      return getEmptyState();
    case "DBOT_STORED_POINTER_POP":
      return {
        ...state,
        storedPointers: state.storedPointers.length === 0 ? [] : state.storedPointers.slice(1)
      };
    case "DBOT_STORED_POINTER_PUSH":
      return {
        ...state,
        storedPointers: [action.payload, ...state.storedPointers]
      };
    case "DBOT_SET_CURRENT_API" :
      return {...state, blockApi: action.payload, apis : addOrReplace(state.apis, action.payload)}
    ;
    case "UPDATE_BUTTONSDELAY":
      return {
        ...state,
        buttonsDelay: action.payload
      };
    default:
      break;
  }
  return state;
};

function getEmptyState() {
  return {
    apis : [],
    records: [],
    storedPointers: [],
    buttonsDelay: 0
  };
}

const addOrReplace = (currentApis, newApi) => {
  return currentApis.some(a => a.blockName === newApi.blockName) ?
      currentApis.map(a => a.blockName === newApi.blockName ? newApi : a) :
      [...currentApis, newApi]
}